// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__IhrsJ","content":"LayoutSettings_content__3nHZC"};